import {DocksActionsContext} from 'modules/reports/contexts/docks'
import {useContext} from 'react'

function useDock() {
  return useContext(DocksActionsContext)
}

export default useDock
